import React from "react";
import { useNavigate } from "react-router-dom";
import "./user_responsibility.scss";

const liabilityItems = [
  "the use or misuse of AI-generated content",
  "the generation of NSFW, explicit, or unintended material",
  "any inaccuracies or errors in the generated outputs",
  "reliance on such content for any purpose",
  "unauthorized sharing or misuse of content by users or third parties",
  "interruptions, delays, or failures caused by third-party services",
];

const UserResponsibility = () => {
  const navigate = useNavigate();

  return (
    <div className="user-responsibility-page">
      <div className="user-responsibility-shell">
        <button
          type="button"
          className="user-responsibility-back"
          onClick={() => navigate(-1)}
        >
          <i className="fi fi-rr-arrow-small-left"></i>
          Back
        </button>

        <header className="user-responsibility-hero">
          <span>Required Acknowledgement</span>
          <h1>User Responsibility</h1>
          <p>
            Please review your responsibilities before generating AI-based
            images, videos, or other media through Zullu AI.
          </p>
        </header>

        <section className="user-responsibility-panel">
          <p>
            By using this platform, you acknowledge that all content generated
            through our AI system, including videos and other media, is produced
            automatically and may contain inaccuracies, unintended elements, or
            content that may be sensitive or not safe for work (NSFW).
          </p>
          <p>
            You agree that you are solely responsible for reviewing, filtering,
            and deciding how to use or handle any content generated. You will
            ensure that your use of the platform complies with all applicable
            laws, regulations, and community standards. You further agree not to
            use the platform to create, upload, or engage with unlawful,
            harmful, abusive, or prohibited content.
          </p>

          <div className="responsibility-section">
            <h2>Personal Use & Non-Sharing</h2>
            <p>
              All content generated through this platform is intended strictly
              for personal and private use only. Users are strictly prohibited
              from sharing, distributing, publishing, broadcasting, or otherwise
              making such content available to any third party without prior
              written consent.
            </p>
            <p>
              Any unauthorized use, reproduction, or distribution of the
              generated content is solely the responsibility of the user.
            </p>
          </div>

          <div className="responsibility-section">
            <h2>NSFW Content Notice</h2>
            <p>
              Due to the nature of artificial intelligence, the platform may
              generate content that is explicit, sensitive, or not safe for work
              (NSFW). We do not guarantee that all outputs will be appropriate
              or suitable for all audiences.
            </p>
            <p>
              Users are solely responsible for reviewing and handling such
              content and must ensure that any generated material complies with
              applicable laws and does not violate the rights of any individual.
            </p>
          </div>

          <div className="responsibility-section">
            <h2>Third-Party Services Disclaimer</h2>
            <p>
              This platform utilizes third-party APIs and technologies to
              generate AI-based content. These services operate independently,
              and we do not own or control their systems, outputs, or
              performance.
            </p>
            <p>
              We do not guarantee the accuracy, reliability, legality, or
              appropriateness of any content generated through such third-party
              services.
            </p>
          </div>

          <div className="responsibility-section">
            <h2>Limitation of Liability</h2>
            <p>
              We shall not be held responsible or liable, under any
              circumstances, for any loss, damage, legal issue, claim, or
              consequence arising directly or indirectly from:
            </p>
            <ul>
              {liabilityItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="responsibility-section">
            <h2>No Endorsement or Guarantee</h2>
            <p>
              The platform does not endorse, verify, or guarantee the
              correctness, legality, or suitability of any generated content. All
              outputs are automated and should be used at the user's own
              discretion and risk.
            </p>
          </div>

          <div className="responsibility-acceptance">
            <h2>Acceptance of Terms</h2>
            <p>
              By accessing or using this platform, you confirm that you have
              read, understood, and agreed to these disclaimers. Continued use
              of the platform constitutes full acceptance of these terms.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default UserResponsibility;
